module.exports = __webpack_public_path__ + "img/title_3.5442a695.png";